import React from 'react';
import { Button, TextField, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import { ListResetIcon } from '../../../../constants';
import Style from './Style';

const useStyles = makeStyles(() => Style());

export default function VehicleInfo({ vehicleInfo, onClear, disabled }) {
  const classes = useStyles();

  return (
    <div className={classes.search__bar}>
      <TextField
        type='text'
        name='search'
        placeholder='Vehicle Information'
        value={vehicleInfo}
        fullWidth
        InputProps={{
          disableUnderline: true,
        }}
        className={classes.search__field}
        disabled
      />
      <Button
        onClick={onClear}
        className={clsx(classes.clear__btn, disabled && classes.disabled__btn)}
        disabled={disabled}
      >
        <ListResetIcon /> Clear
      </Button>
    </div>
  );
}
